import {
  EntityKind,
  PaginatedEntities
} from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';

const fetchEvents = async (): Promise<PaginatedEntities | undefined> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await getClient()?.listEntities({
    kind: EntityKind.EVENT,
    projectId: currentProject._id
  });

  return data;
};

export const useGetEvents = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.EVENTS], () => fetchEvents(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
